import Big from "big.js";
import moment from "moment-timezone";
import IntlRelativeFormat from "intl-relativeformat";
import { cc, Formats } from "../index";
const locale = "en-NZ";
const timezone = cc.timezone;
const numberFormatter = new Intl.NumberFormat(locale, {});
const relativeFormatter = new IntlRelativeFormat(locale);
export function momentNow() {
    return moment.tz(cc.timezone).locale(locale);
}
export function momentFromFormat(dt, format) {
    return moment.tz(dt, format, timezone).locale(locale);
}
export function momentFromMillis(dt, format) {
    return moment.tz(dt, timezone).locale(locale);
}
export function formatNumber(value) {
    return numberFormatter.format(typeof value === "string" ? parseFloat(value) : value);
}
export function formatDateTime(ts) {
    return moment.tz(ts, timezone).format("DD/MM/YYYY hh:mm a");
}
export function formatDateTimeSimple(ts) {
    return moment.tz(ts, timezone).format("DD/MM, hh:mm a");
}
export function formatTime(ts) {
    return moment.tz(ts, timezone).format("hh:mm a");
}
export function formatTimeFromTime(time) {
    return moment.tz(time, Formats.moment.time, timezone).format("hh:mm a");
}
export function formatDate(ts) {
    return moment.tz(ts, timezone).format("DD/MM/YYYY");
}
export function formatDateSimple(ts) {
    return moment.tz(ts, timezone).format("DD/MM");
}
export function formatDateFromDate(date) {
    return moment.tz(date, Formats.moment.date, timezone).format("DD/MM/YYYY");
}
export function formatDateFriendly(ts) {
    return moment.tz(ts, timezone).format("Do MMM YYYY");
}
export function formatDayOfWeek(day) {
    return {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
    }[day.toLowerCase()];
}
export function formatRelative(ts) {
    return relativeFormatter.format(new Date(ts));
}
export function metersToKm(meters) {
    return Big(meters).div(1000).toFixed(3);
}
export function secondsToMinutes(seconds) {
    return Big(seconds).div(60).toFixed(0);
}
export function formatMetersToKm(meters) {
    return `${metersToKm(meters)}km`;
}
export function formatOrderNumber(order) {
    const { number, terminal_session_id } = order;
    const isPos = !!terminal_session_id;
    const strNumber = number.toString();
    if (!isPos)
        return strNumber;
    if (strNumber.length === 1)
        return `P-00${number}`;
    if (strNumber.length === 2)
        return `P-0${number}`;
    return `P-${number}`;
}
export function formatOrderStatus(status) {
    return {
        unconfirmed: "Un-Confirmed",
        confirmed: "Confirmed",
        ready: "Ready",
        on_route: "On Route",
        complete: "Complete",
        cancelled: "Cancelled",
    }[status];
}
export function formatServiceType(service) {
    return {
        pickup: "Pickup",
        delivery: "Delivery",
        dine_in: "Dine-In",
        table_booking: "Table Booking",
    }[service];
}
export function formatAddressObjectDisplay(address) {
    let display = `${address.street}, ${address.suburb}, ${address.city}`;
    if (address.number) {
        display = `${address.number} ${display}`;
    }
    if (address.unit) {
        display = `${address.unit} - ${display}`;
    }
    return display;
}
export function cleanPhoneNumber(phone) {
    phone = phone.replace(/\(/g, "");
    phone = phone.replace(/\)/g, "");
    phone = phone.replace(/\+/g, "");
    phone = phone.replace(/ /g, "");
    phone = phone.trim();
    if (phone.startsWith("64")) {
        phone = `0${phone.slice(2)}`;
    }
    if (phone[0] !== "0")
        phone = "0" + phone;
    return phone;
}
//# sourceMappingURL=index.js.map